/**
 * Screenshot/export-only dependency (429 KB source) — load it on demand
 * rather than pinning it into the eager entry chunk. Every call site is
 * already inside an async handler, so this is a drop-in replacement for a
 * static `import html2canvas from 'html2canvas-pro'`.
 */
export const loadHtml2Canvas = async (): Promise<
  typeof import('html2canvas-pro').default
> => (await import('html2canvas-pro')).default
